


































































































































































// Utils
import StateEnum from '~/utils/StateEnum';

// Data imports
import MessageState from '~/store/customModules/messageModule';

// Component specific components
import UniConnections from './UniConnections.vue';
import PersonalDetailsSkeleton from '../skeletons/PersonalDetailsSkeleton.vue';
import { Candidate } from '~/services/CandidateService';
import Vue, { PropType } from 'vue';
import { User } from '~/services/IdentityService';
import { IMissingFieldValidation } from '~/utils/user/validateCandidateData';
import { VFairProfileRequirementLevel } from '~/services/VFairService';

// Constants
const PRONOUN_TYPE_MALE = 'he/him';
const PRONOUN_TYPE_FEMALE = 'she/her';
const PRONOUN_TYPE_PLURAL = 'they/them';
const PRONOUN_TYPE_PREFER_NOT_TO_SAY = 'prefer_not_to_say';
export const PRONOUN_TYPE_OTHER = 'other';

const DISABILITY_YES = 'yes';
const DISABILITY_NO = 'no';
const DISABILITY_PREFER_NOT_TO_SAY = 'prefer_not_to_say';

export default Vue.extend({
    name: 'PersonalDetails',
    components: { UniConnections, PersonalDetailsSkeleton },
    props: {
        value: {
            type: Object as PropType<User>,
            required: true,
        },
        candidateData: {
            type: Object as PropType<Candidate>,
            required: true,
        },
        isLoading: Boolean,
        requiredFields: {
            type: Object as PropType<IMissingFieldValidation>,
            required: true,
        },
        requirementLevel: {
            type: String as PropType<VFairProfileRequirementLevel>,
            default: VFairProfileRequirementLevel.Regular,
        },
    },
    data: () => ({
        isChecked: false,
        StateEnum: StateEnum,
        imgUrl: null,
    }),
    computed: {
        interfaces(): any {
            return (this as any).$interfaces;
        },

        minimal(): boolean {
            return this.requirementLevel === VFairProfileRequirementLevel.Minimum;
        },

        user(): { data: User | null } {
            return this.interfaces.user.me.get({ reactive: true }) || { data: null };
        },
        selectedPronounType(): string {
            let pronoun = this.candidateData.pronoun;
            return pronoun != null ? pronoun.type : '';
        },
        selectedPronounValue(): string {
            let pronoun = this.candidateData.pronoun;
            return pronoun != null ? pronoun.value : '';
        },
        isPronounTypeOther(): boolean {
            return this.selectedPronounType == PRONOUN_TYPE_OTHER;
        },
    },
    methods: {
        requiredFieldParser(message: string, required: boolean) {
            return message.concat(required ? ':*' : ':');
        },
        resetChangedImage(): void {
            this.imgUrl = null;
        },
        handleRemoveImage(): void {
            // @ts-ignore
            this.$refs['fileInput'].value = '';
            if (this.imgUrl && this.imgUrl !== this.value.image) {
                this.imgUrl = null;
                this.$emit('image:removed');
            } else {
                this.$emit('removeOldImage');
            }
        },
        alert(str: string) {
            alert(str);
        },
        onFileChange(fileName: string, files: File[]) {
            if (files.length > 0) {
                let imageFile = files[0];
                if (!imageFile.type.match('image.*')) {
                    // @ts-ignore
                    this.$interfaces.messageModule.addNewMessage({
                        title: this.$t('spotlight.personalDetails.wrongFileTypeErrorHeader'),
                        message: this.$t('spotlight.personalDetails.wrongFileTypeErrorDescription'),
                        // @ts-ignore
                        state: MessageState.NOTIFICATION,
                        duration: 6000,
                    });
                } else {
                    // @ts-ignore
                    this.imgUrl = URL.createObjectURL(imageFile);
                    this.$emit('image:changed', imageFile);
                }
            }
        },
        onNationalityChange(newVal: any) {
            this.$emit('input', {
                ...this.value,
                nationality: newVal ? newVal.value : null,
            });
        },
        onGenderChange(newVal: string) {
            this.$emit('input', {
                ...this.value,
                gender: newVal ? newVal : 'U',
            });
        },
        onPronounChange(newVal: string) {
            this.$emit('candidate:change', {
                ...this.candidateData,
                pronoun: {
                    type: newVal,
                    value:
                        newVal === PRONOUN_TYPE_OTHER
                            ? (this.candidateData.pronoun || {}).value
                            : '',
                },
            });
        },
        onDisabilityChange(newVal: string) {
            this.$emit('candidate:change', {
                ...this.candidateData,
                disability: newVal,
            });
        },
        firstLetterOfName(): string {
            const userData = this.user.data;
            return userData && userData.firstName ? userData.firstName[0] : 'A';
        },
        getGenderOptions() {
            return [
                {
                    value: 'M',
                    label: this.$t('spotlight.personalDetails.genderOptions.male'),
                },
                {
                    value: 'F',
                    label: this.$t('spotlight.personalDetails.genderOptions.female'),
                },
                {
                    value: 'O',
                    label: this.$t('spotlight.personalDetails.genderOptions.other'),
                },
                {
                    value: 'N',
                    label: this.$t('spotlight.personalDetails.genderOptions.none'),
                },
            ];
        },
        getPronounOptions() {
            return [
                {
                    value: PRONOUN_TYPE_MALE,
                    label: this.$t('spotlight.personalDetails.pronounOptions.male'),
                },
                {
                    value: PRONOUN_TYPE_FEMALE,
                    label: this.$t('spotlight.personalDetails.pronounOptions.female'),
                },
                {
                    value: PRONOUN_TYPE_PLURAL,
                    label: this.$t('spotlight.personalDetails.pronounOptions.plural'),
                },
                {
                    value: PRONOUN_TYPE_PREFER_NOT_TO_SAY,
                    label: this.$t('spotlight.personalDetails.pronounOptions.preferNotToSay'),
                },
                {
                    value: PRONOUN_TYPE_OTHER,
                    label: this.$t('spotlight.personalDetails.pronounOptions.other'),
                },
            ];
        },
        getDisabilityOptions() {
            return [
                {
                    value: DISABILITY_YES,
                    label: this.$t('spotlight.personalDetails.disabilityOptions.yes'),
                },
                {
                    value: DISABILITY_NO,
                    label: this.$t('spotlight.personalDetails.disabilityOptions.no'),
                },
                {
                    value: DISABILITY_PREFER_NOT_TO_SAY,
                    label: this.$t('spotlight.personalDetails.disabilityOptions.preferNotToSay'),
                },
            ];
        },
    },
});
